import Badge from "@/components/ui/badge";
import Text from "@/components/ui/text";
import {
  getTagColorForMilestone,
  getBorderColorForMilestone
} from "@/components/shared/Milestones";
import { DealMilestone } from "@/components/shared/DealMilestone";
import HighlightedText from "@/components/controls/HighlightedText";
import { cn } from "@/utils/utils";

/** The stage fields the badge renders. */
export interface StageBadgeStage {
  name: string;
  milestone: DealMilestone;
}

export interface StageBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  stage?: StageBadgeStage;
  isTable?: boolean;
  /** Search term to highlight inside the stage name. */
  highlight?: string;
}

function StageBadge({ stage, isTable, highlight }: StageBadgeProps) {
  const tagColor = getTagColorForMilestone(stage?.milestone);
  const borderColor = getBorderColorForMilestone(stage?.milestone);

  const stageName = stage?.name || "";

  return (
    <Badge
      className="py-1 px-2 rounded-md max-w-full overflow-hidden"
      style={{ backgroundColor: tagColor, borderColor }}
    >
      <Text
        variant="body"
        className={cn("truncate", isTable && "text-sm")}
        hasTruncatedTooltip
      >
        {highlight?.trim() ? (
          <HighlightedText text={stageName} query={highlight} />
        ) : (
          stageName
        )}
      </Text>
    </Badge>
  );
}

export { StageBadge };
